import { stringify } from 'qs';
import request from '@/utils/request';

export async function login(params) {
  return request(
    '/login',
    {
      method: 'POST',
      body: stringify(params),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    },
    false
  );
}

export function zmpLogin(params) {
  return request('/zmpLogin', {
    method: 'POST',
    body: stringify(params),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
  });
}

export async function changeUserPwd(params) {
  return request('/prod/users/self/pwd', {
    method: 'PATCH',
    body: params,
  });
}

export async function logout() {
  return request('/logout', {});
}

export async function logged() {
  return request('/logged', {});
}

export async function current(param) {
  return request('/menus/current', {
    method: 'POST',
    body: param,
  });
}

export async function querySysparams() {
  // TODO 这里的接口不合理，2，3，4返回的值是作为时间格式来用的
  return request('/sysparams/common');
}

export async function qryCurrentSecurityRule() {
  return request('/sysparams/securityrules/current');
}

export async function queryAdmin() {
  return request('/users/admin');
}

export async function queryUserPortals(param) {
  return request(`/users/${param.userId}/portals`);
}

export async function queryCurrent() {
  return request('/users/current');
}

export async function queryMenuUrl() {
  return request('/menus/url?url=');
}

export async function queryLocal() {
  return request('/local', {});
}
export async function queryLangs() {
  return request('/languages', {});
}

export async function addComponentPrivilege(method, params) {
  return request('/components', {
    method,
    body: params,
  });
}

export async function checkComponentPrivilege(params) {
  return request(`/components/checked?${stringify(params)}`);
}

export async function getMenuComponentPrivs(menuId) {
  return request(`/menus/${menuId}/out/components`);
}

export async function delComponentPrivs(privId) {
  return request(`/components/${privId}`, {
    method: 'DELETE',
  });
}

export async function getAsyncConfig(params) {
  return request(`/sysparams/async?${stringify(params)}`);
}

export async function getMagicCode(params) {
  // TODO 这样用法不对，前台取不到用户的密码，登陆之后通过当前用户来调用magiccode服务即可
  return request('/magiccode', {
    method: 'POST',
    body: params,
    // headers: { Authorization: `Basic ${btoa(`${params.targetUserCode}:${params.password}`)}` },
  });
}

// 为用户新增默认角色权限
export async function grantDefaultRole(userId, params) {
  return request(`/users/${userId}/roles`, {
    method: 'POST',
    body: params,
  });
}

export async function queryUserRoles(userId) {
  // TODO 这里的服务不应该传入userId，存在篡改风险
  return request(`/users/${userId}/roles`);
}

export async function getVerifyAndSmsCodeEnabled() {
  return request('/verificationandsmscode/enabled');
}

// 记录浏览器日志
export async function addBrowserLog(params) {
  return request('/browser/add/log', {
    method: 'POST',
    body: params,
  });
}

// 获取流程
export async function getFlowList(params) {
  return request('/workFlow/flow/tempts/list', {
    method: 'POST',
    body: params,
  });
}

// 初始化流程
export async function initProcess(params) {
  return request('/workFlow/flow/procs/simpleInitProcess', {
    method: 'POST',
    body: params,
  });
}

// 启动流程
export async function startProcess(params) {
  return request('/workFlow/flow/procs/start/button', {
    method: 'POST',
    body: params,
  });
}

// 按钮流程绑定
export async function componentFlowBind(params) {
  return request('/workFlow/flow/component-flow/bind', {
    method: 'POST',
    body: params,
  });
}

// 按钮流程查询
export async function getComponentFlow(params) {
  return request(`/workFlow/flow/component-flow/get/${params.menuId}/${params.objId}`);
}

// 按钮流程更新
export async function componentFlowUpdate(params) {
  return request('/workFlow/flow/component-flow/update', {
    method: 'POST',
    body: params,
  });
}

// 获取当前登录用户信息并写入session
export async function staffCurrent() {
  return request('/stafforg/staff/current', {
    method: 'POST',
  });
}

// 是否需要执行 staffJob
export function orgJobsEnabled() {
  return request('/stafforg/enabled');
}

// staffJob 列表
export function getOrgJobs() {
  return request('/stafforg/staffs/self/orgjobs');
}

// staff 执行
export function currentStaffJob(params) {
  return request('/stafforg/staffjob/current', {
    method: 'POST',
    body: params,
  });
}

export async function getInterval() {
  return request('/online/timeout/interval');
}

export async function getRemainingTime() {
  return request('/online/timeout/refresh');
}

export async function getNoticeTime() {
  return request('/online/timeout/t1');
}

export async function recoverSession() {
  return request('/online/refreshAccTime');
}
